import Balances from '@app/features/billing/Balances/Balances';

const BalancesPage = () => {
  return <Balances />;
};

export default BalancesPage;
